import { render, staticRenderFns } from "./cardInternationalProduct.vue?vue&type=template&id=0b7a93c7&scoped=true&"
import script from "./cardInternationalProduct.vue?vue&type=script&lang=js&"
export * from "./cardInternationalProduct.vue?vue&type=script&lang=js&"
import style0 from "./cardInternationalProduct.vue?vue&type=style&index=0&id=0b7a93c7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a93c7",
  null
  
)

export default component.exports